export default "__VITE_ASSET__CUTPbNNI__"